import { render, staticRenderFns } from "./ObiRow.vue?vue&type=template&id=73e4d312&scoped=true&"
import script from "./ObiRow.vue?vue&type=script&lang=js&"
export * from "./ObiRow.vue?vue&type=script&lang=js&"
import style0 from "./ObiRow.vue?vue&type=style&index=0&id=73e4d312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e4d312",
  null
  
)

export default component.exports